import { extends as _extends } from '../../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Brandy from '../../Brandy/index.js';
import Price from '../../Price/index.js';
import { PackageCard, CustomTextContainer, CustomText } from './DefaultPackageCard.styles.js';
import Label from '../Label/Label.js';
import NameAndDescription from '../NameAndDescription/NameAndDescription.js';
import Details from '../Details/Details.js';
import Bullets from '../Bullets/Bullets.js';
import MainContent from '../MainContent/MainContent.js';

var DefaultPackageCard = function DefaultPackageCard(_ref) {
  var _packageData$details, _packageData$price, _packageData$price2, _packageData$price3, _packageData$price4, _packageData$price5, _packageData$price6;
  var labelData = _ref.labelData,
    labelRef = _ref.labelRef,
    height = _ref.height,
    packageData = _ref.packageData,
    modal = _ref.modal,
    children = _ref.children,
    content = _ref.content;
  return /*#__PURE__*/React__default.createElement(PackageCard, {
    className: "wrapper default"
  }, labelData && /*#__PURE__*/React__default.createElement(Label, {
    labelRef: labelRef,
    height: height,
    labelType: labelData === null || labelData === void 0 ? void 0 : labelData.type,
    text: labelData === null || labelData === void 0 ? void 0 : labelData.text
  }), /*#__PURE__*/React__default.createElement(NameAndDescription, {
    name: packageData === null || packageData === void 0 ? void 0 : packageData.name,
    description: packageData === null || packageData === void 0 ? void 0 : packageData.description
  }), (packageData === null || packageData === void 0 ? void 0 : packageData.details) && ((_packageData$details = packageData.details) === null || _packageData$details === void 0 ? void 0 : _packageData$details.length) > 0 && /*#__PURE__*/React__default.createElement(Details, {
    packageData: packageData === null || packageData === void 0 ? void 0 : packageData.details
  }), (packageData === null || packageData === void 0 || (_packageData$price = packageData.price) === null || _packageData$price === void 0 ? void 0 : _packageData$price.amount) && /*#__PURE__*/React__default.createElement(Price, _extends({
    className: "price"
  }, packageData === null || packageData === void 0 ? void 0 : packageData.price, {
    inPackageCard: true,
    nutrition: packageData === null || packageData === void 0 ? void 0 : packageData.nutrition,
    priceOld: packageData === null || packageData === void 0 ? void 0 : packageData.priceOld
  })), (packageData === null || packageData === void 0 || (_packageData$price2 = packageData.price) === null || _packageData$price2 === void 0 ? void 0 : _packageData$price2.custom) && /*#__PURE__*/React__default.createElement(CustomTextContainer, null, /*#__PURE__*/React__default.createElement(CustomText, {
    inPackageCard: true
  }, packageData === null || packageData === void 0 || (_packageData$price3 = packageData.price) === null || _packageData$price3 === void 0 ? void 0 : _packageData$price3.custom), (packageData === null || packageData === void 0 || (_packageData$price4 = packageData.price) === null || _packageData$price4 === void 0 ? void 0 : _packageData$price4.disclaimer) && /*#__PURE__*/React__default.createElement(Brandy, {
    className: "bullet-disclaimer",
    symbol: (_packageData$price5 = packageData.price) === null || _packageData$price5 === void 0 || (_packageData$price5 = _packageData$price5.disclaimer) === null || _packageData$price5 === void 0 ? void 0 : _packageData$price5.symbol,
    text: (_packageData$price6 = packageData.price) === null || _packageData$price6 === void 0 || (_packageData$price6 = _packageData$price6.disclaimer) === null || _packageData$price6 === void 0 ? void 0 : _packageData$price6.text,
    variant: "legal"
  })), modal && /*#__PURE__*/React__default.createElement("span", {
    className: "modal"
  }, modal), /*#__PURE__*/React__default.createElement(Bullets, {
    bullets: packageData === null || packageData === void 0 ? void 0 : packageData.bullets
  }), children && children, /*#__PURE__*/React__default.createElement(MainContent, {
    content: content
  }));
};
var DefaultPackageCard$1 = DefaultPackageCard;

export { DefaultPackageCard$1 as default };
//# sourceMappingURL=DefaultPackageCard.js.map
